<template>
	<div class="heiht-100dvh">
		<NcdTopContainer />
		<div
			class="acc-mainbackground d-flex align-items-center justify-content-center"
		>
			<div
				class="acc-disabled-maincontainer h-100 w-100 d-flex align-items-center justify-content-center"
			>
				<div
					class="w-65 d-flex align-items-center flex-column justify-content-center"
				>
					<div id="hideinlaptop" class="mb-3">
						<img
							src="../assets/icons/candidatedashboard/canddashright/accountdisabled.svg"
							alt=""
						/>
					</div>
					<div class="acc-disabled-heading mob-fs-16">
						We're sorry, but it seems that the account you are looking
						<br id="hideinmobile" />
						for is not currently active. <br id="hideinmobile" />
						Here are a few possible reasons for this:
					</div>
					<div class="mr-128">
						<div class="mt-3">
							<div class="acc-disabled-subheading">Incorrect share link:</div>
							<div class="acc-disabled-subheading2">
								Please double-check the link sent for any errors in the link
								name
							</div>
						</div>
						<div class="mt-3">
							<div class="acc-disabled-subheading">
								Account Deactivated or Deleted:
							</div>
							<div class="acc-disabled-subheading2">
								If the account is deactivated or deleted , you won't be able to
								access it.
							</div>
						</div>
					</div>
				</div>
				<div id="hideinmobile" class="w-35">
					<img
						src="../assets/icons/candidatedashboard/canddashright/accountdisabled.svg"
						alt=""
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";

export default {
	name: "AccountDisabled",
	components: {
		NcdTopContainer,
	},
	methods: {
		goBack() {
			this.$router.push({
				name: "CandidateDashboard",
			});
		},
	},
};
</script>
<style>
.w-65 {
	width: 65%;
}
.w-35 {
	width: 35%;
}
.acc-disabled-maincontainer {
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.acc-mainbackground {
	background: #e9ecef;
	height: calc(100vh - 60px);
	width: 100%;
	position: relative;
	top: 60px;
	padding: 20px 55px 20px 55px;
}
.acc-disabled-heading {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 25px;
	color: #000000;
}
.acc-disabled-subheading {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 15px;
	color: #3a3c40;
}
.acc-disabled-subheading2 {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #3a3c40;
}
.mr-128 {
	margin-right: 128px;
}
@media (max-width: 1028px) {
	.acc-mainbackground {
		background: #e9ecef;
		height: calc(100dvh - (60px + env(safe-area-inset-top)));
		width: 100%;
		position: relative;
		top: unset;
		padding: 15px;
	}
	.acc-disabled-maincontainer {
		display: unset !important;
		padding: 15px;
		gap: 15px;
		overflow: auto;
	}

	.acc-mainbackground img,
	.acc-mainbackground .w-65 {
		width: 100%;
	}
	.acc-mainbackground .mr-128 {
		margin-right: 0;
	}
}
</style>
